import { formatINR } from '@/lib/format';
import { useNavigate } from 'react-router-dom';

export default function KpiCard({ label, value, sublabel, accent, testId, isCurrency = false, to }) {
    const nav = useNavigate();
    const display = isCurrency ? formatINR(value) : (value ?? '—');
    const interactive = !!to;
    const commonClasses = `surface-1 rounded-md p-5 ${interactive ? 'hover-lift cursor-pointer text-left group' : 'hover-lift'} w-full`;
    const inner = (
        <>
            <div className="flex items-center justify-between">
                <div className="overline">{label}</div>
                {interactive && (
                    <span className="text-[10px] uppercase tracking-wider text-slate-400 group-hover:text-[#016a6d] transition-colors">View →</span>
                )}
            </div>
            <div className={`font-display text-3xl font-bold mt-3 tabular-nums ${accent || 'text-slate-900'}`}>
                {display}
            </div>
            {sublabel && <div className="text-xs text-slate-500 mt-2 tabular-nums">{sublabel}</div>}
        </>
    );
    if (interactive) {
        return (
            <button type="button" onClick={() => nav(to)} data-testid={testId} className={commonClasses}>
                {inner}
            </button>
        );
    }
    return <div data-testid={testId} className={commonClasses}>{inner}</div>;
}
